export default class ObjectHelper {
  static assign({ ...obj }) {
    const target = {}

    Object.assign(target, { ...obj })

    // for (const i in target) {
    //   if (typeof target[i] === 'function') {
    //   }
    // }

    return target
  }

  /**
   * @param obj
   * @param keys
   * @returns {Object}
   */
  static map(obj, keys) {
    if (typeof obj !== 'object' || !Array.isArray(keys)) {
      throw new Error('Incorrect arguments')
    }

    const o = {}

    // eslint-disable-next-line guard-for-in
    for (const key in keys) {
      const field = keys[key]
      o[field] = obj.hasOwnProperty(field) ? obj[field] : null
    }

    return o
  }

  /**
   *
   * @param list
   * @param keys
   * @returns {Array}
   */
  static mapList(list, keys) {
    if (!Array.isArray(list) || !Array.isArray(keys)) {
      throw new Error('Incorrect arguments')
    }

    const a = []

    // eslint-disable-next-line guard-for-in
    for (const index in list) {
      const item = list[index]
      const o = {}

      if (typeof item !== 'object') {
        throw new Error('Incorrect item type in list argument')
      }

      // eslint-disable-next-line guard-for-in
      for (const key in keys) {
        const field = keys[key]
        o[field] = item.hasOwnProperty(field) ? item[field] : null
      }

      a.push(o)
    }

    return a
  }
}
